export type BookingTypeDisplay =
  | "ONLINE"
  | "OFFLINE"
  | "SUBSCRIPTION"
  | "UNKNOWN";

type BookingTypeInput = string | null | undefined;

const BOOKING_TYPE_BADGE_STYLES: Record<BookingTypeDisplay, string> = {
  ONLINE: "bg-blue-50 text-blue-700 border-blue-100",
  OFFLINE: "bg-orange-50 text-orange-700 border-orange-100",
  SUBSCRIPTION: "bg-purple-50 text-purple-700 border-purple-100",
  UNKNOWN: "bg-slate-50 text-slate-700 border-slate-200",
};

export function normalizeBookingType(
  bookingType: BookingTypeInput,
): BookingTypeDisplay {
  const normalized = (bookingType ?? "").toUpperCase();

  if (normalized === "ONLINE") return "ONLINE";
  if (normalized === "OFFLINE") return "OFFLINE";
  if (normalized === "SUBSCRIPTION") return "SUBSCRIPTION";

  return "UNKNOWN";
}

export function getBookingTypePresentation(bookingType: BookingTypeInput): {
  value: BookingTypeDisplay;
  label: BookingTypeDisplay;
  badgeClassName: string;
} {
  const value = normalizeBookingType(bookingType);

  return {
    value,
    label: value,
    badgeClassName: BOOKING_TYPE_BADGE_STYLES[value],
  };
}
